import { FC } from 'react';
import { Col } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ToggleBox from '~src/shared/form/toggleBox/ToggleBox';
import { TextBox } from '~src/styles/containers.sc';

export const ToggleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

interface Props {
  onChange: (newState: boolean) => Promise<unknown>;
  initialState: boolean;
  translationKeys: { label: string; off: string; on: string; }
}

const ToggleRow: FC<Props> = ({ onChange, initialState, translationKeys }) => {
  const { t } = useTranslation();
  return (<>
      <Col span={18}>
        <TextBox data-translation={translationKeys.label}>
          {t(translationKeys.label)}
        </TextBox>
      </Col>
      <Col span={6}>
        <ToggleContainer
          data-translation={[
            translationKeys.on,
            translationKeys.off,
          ]}
        >
          <ToggleBox
            size="big"
            title={[
              t(translationKeys.on),
              t(translationKeys.off),
            ]}
            active={initialState}
            onChangeBox={onChange}
          />
        </ToggleContainer>
      </Col>
    </>
  );
};

export default ToggleRow;
